import { useEffect, useState } from "react";
import { baixarVersaoNova } from "./cacheApp";

/** O coletor fica aberto o turno inteiro: de tempos em tempos confere se saiu versão nova. */
const INTERVALO = 5 * 60_000;

/**
 * true quando o servidor já tem outra versão do app (versao.json, gerado no build com o mesmo
 * commit de __VERSAO__). A tela avisa e a pessoa atualiza quando terminar o que está fazendo:
 * uma cópia antiga aberta pode chamar uma RPC que mudou na última migration.
 */
export function useVersaoNova(): boolean {
  const [nova, setNova] = useState(false);
  useEffect(() => {
    if (import.meta.env.DEV) return;   // npm run dev já recarrega sozinho
    let ativo = true;
    const conferir = async () => {
      try {
        const r = await fetch(`/versao.json?t=${Date.now()}`, { cache: "no-store" });
        if (!r.ok) return;
        const { versao } = (await r.json()) as { versao?: string };
        if (ativo && versao && versao !== __VERSAO__) {
          setNova(true);
          baixarVersaoNova();
        }
      } catch {
        // sem internet: confere na próxima
      }
    };
    const id = setInterval(() => void conferir(), INTERVALO);
    const aoVoltar = () => { if (document.visibilityState === "visible") void conferir(); };
    document.addEventListener("visibilitychange", aoVoltar);
    return () => {
      ativo = false;
      clearInterval(id);
      document.removeEventListener("visibilitychange", aoVoltar);
    };
  }, []);
  return nova;
}
